import CardCarItem from './CardCarItem';

import useConfiguratorData from '../../hooks/useConfiguratorData';

const ModelsList = ({selectedMotor}) => {

    const { getFilteredModels } = useConfiguratorData();

    const filteredModels = getFilteredModels();

    return (
        <div className="models-list-container">
            {filteredModels.map(model => (
                <CardCarItem model={model} selectedMotor={selectedMotor} key={`model-${model.id}`} />
            ))}
        </div>
    )  
}

export default ModelsList;